// @flow

import React, { Component } from 'react';
import DroppablePiece from './DroppablePiece';
import type { PiecesData, PieceData, PlacePuzzlePiece } from './types';

type Props = {
  piecesData: PiecesData,
  placePuzzlePiece: PlacePuzzlePiece,
  fieldWidth: number,
};

class PuzzleField extends Component<Props> {
  renderPiece(pieceData: PieceData, index: number): React$Element<any> {
    const { placePuzzlePiece, fieldWidth } = this.props;

    return (
      <DroppablePiece
        pieceData={pieceData}
        index={index}
        placePuzzlePiece={placePuzzlePiece}
        finished={pieceData.finished}
        key={`droppable-${index}`}
        fieldWidth={fieldWidth}
      />
    );
  }

  render(): React$Element<any> {
    const { piecesData, fieldWidth } = this.props;

    const sizing = {
      width: fieldWidth,
      height: fieldWidth,
    };

    return (
      <div className="puzzle__wrapper">
        <div className="puzzle__field" style={sizing}>
          {piecesData.map((pieceData, index) =>
            this.renderPiece(pieceData, index),
          )}
        </div>
      </div>
    );
  }
}

export default PuzzleField;
